import {
  getElementByClassName,
  getElementStyleProperty,
} from 'lib/utils/common/commonUtils'

const getActualInfoContainerWidth = (isPhone) => {
  if (isPhone) {
    return null
  }

  const infoContainer = getElementByClassName('pdp__information-container', 0)
  const infoContainerLeftPadding = parseInt(
    getElementStyleProperty({
      htmlElem: infoContainer,
      key: 'padding-left',
    })?.match(/\d+/g)?.[0],
    10,
  )
  return (
    (infoContainer?.getBoundingClientRect().width || 0) -
    infoContainerLeftPadding
  )
}

export default getActualInfoContainerWidth
